import { useCallback, useEffect, useState } from "react";
import { FaGamepad } from "react-icons/fa";
import { MdGeneratingTokens } from "react-icons/md";
import { FaGitAlt } from "react-icons/fa6";
import { Application } from "../model/application";
import { FaDiagramNext } from "react-icons/fa6";

const mockData: Application[] = [
   {
    title: "Platuml Live Editor",
    icon: FaDiagramNext,
    gradientFrom: "#7288AE",
    gradientTo: "#4B5694",
    externalUrl: "https://plantuml.oakraw.com/",
  },
   {
    title: "Git Diagram",
    icon: FaGitAlt,
    gradientFrom: "#BFDDF0",
    gradientTo: "#8CC0EB",
    externalUrl: "https://git-diagram.oakraw.com/",
  },
  {
    title: "Scrum Poker",
    icon: FaGamepad,
    gradientFrom: "#6FBEB2",
    gradientTo: "#34908B",
    externalUrl: "https://scrumpoker.oakraw.com/",
  },
  {
    title: "Token Swap Watcher",
    icon: MdGeneratingTokens,
    gradientFrom: "#8ACBD0",
    gradientTo: "#56B6C6",
    externalUrl: "https://wanunt-9d51c.web.app/",
  }
];

const useFetchApplication = (): { applications: Application[] | null; fetch: () => void } => {
  const [applications, setApplications] = useState<Application[] | null>(null);
  const fetch = useCallback(async () => {
    setApplications(mockData);
  }, []);

  useEffect(() => {
    fetch();
  }, [fetch]);

  return { applications, fetch };
};

export default useFetchApplication;
